import { OnInit } from '@angular/core';
import { Component } from '@angular/core';
import { AfterViewInit } from '@angular/core';
import { IContextService } from '@pershing/pershing-core';
import { DomainContext } from '@pershing/pershing-core';
import { Subscription } from 'rxjs';
import { PershingTranslationService } from '@pershing/pershing-core';
import { NxiWidgetParamsService } from '../../services/NXI-WidgetParams.service';
import { NxiContextUtils } from '@pershing/nxi-common';

declare let dojoApp: any;

@Component({
    selector: 'dojo-historic-statements',
    templateUrl: './dojo-historic-statements.component.html'
})
export class DojoHistoricStatementComponent implements OnInit, AfterViewInit {
    inputValue: string = '';
    domain: string = '';
    subs: Subscription;
    acctRef: any;
    constructor(private contextService: IContextService,
                private translationService: PershingTranslationService,
                private nxiWidgetParamsService: NxiWidgetParamsService) {
                    this.translationService.addTranslationFolder('@pershing/nxi-ng-portfolio', 'node_modules/@pershing/nxi-ng-portfolio/lib');
    }

    ngOnInit() {
        this.subs = this.contextService.selectedDomainContext$.subscribe((domainContext: DomainContext<any>) => {
            let contextValue = NxiContextUtils.getContextFromDomainValue(domainContext);
            this.inputValue = contextValue.inputValue;
            this.acctRef = contextValue.hashValue;
            this.getHistoricStatementParams();
        });
    }

    renderDojoWidget(acctRef: any): void {
        if (dojoApp) {
            dojoApp.renderHistoricStmt(acctRef);
        }
    }

    ngAfterViewInit(): void {
    }

    ngOnDestroy(): void {
        if (this.subs) {
            this.subs.unsubscribe();
        }
        if (dojoApp) {
            dojoApp.destroyWidget('historicStmtFilter');
            dojoApp.destroyWidget('histStatements');
        }
    }

    getHistoricStatementParams() {
        if (this.inputValue !== '' && this.acctRef !== '') {
            this.renderDojoWidget(this.acctRef);
        }
    }

    closeButtons(): void {
        if (dojoApp) {
            dojoApp.closeTaxStmtButtons();
        }
    }
    handleDocs(): void {
        if (dojoApp) {
            dojoApp.handleTaxStmtsDocs();
        }
    }
    generatePdf(data: any): void {
        if (dojoApp) {
            dojoApp.generatePdf(data);
        }
    }
    gotoRoute(page: string): void {
        document.dispatchEvent(new CustomEvent('portal.gotoview', {
            detail: {
                'gotoPage': page,
                'domain': { 'domain': 'account', 'value': this.acctRef }
            }
        }));
    }

}
